<template>
  <span class="ai-review-actions">
    <!-- 结果被清空（重新上传/编辑保存）后不展示旧报告入口；无已完成结果且未在评审中时显示发起按钮 -->
    <el-button
      v-if="!underway && !(reportLogId && evaluation)"
      size="mini"
      type="primary"
      style="margin-left: 10px"
      @click="$emit('select')"
      >AI智评</el-button
    >
    <!-- AI智评报告链接仅在结果非空时展示，历史报告仅在下方日志中查看 -->
    <a
      v-if="reportLogId && evaluation"
      href="javascript:void(0);"
      style="color: #6495ed; margin-left: 10px"
      @click="$emit('report', reportLogId)"
      >AI智评报告</a
    >
    <template v-else-if="underway">
      （AI评审中）
      <el-button size="mini" type="primary" @click="$emit('refresh')"
        >刷新AI评审结果</el-button
      >
    </template>
    <span v-if="evaluation" style="margin-left: 10px">
      AI智评得分：{{ evaluation }}
    </span>
  </span>
</template>

<script>
/**
 * 「AI智评」操作区（论文列表 / 我的抽检 共用）。
 *
 * 原先该段模板块在 views/thesis/index.vue 中出现两次、在 mySpotCheck.vue 中出现一次，
 * 三份内容完全一致，故收敛为本组件，显隐条件与交互语义保持不变：
 * - 无已完成报告且未在检测中：只显示「AI智评」按钮；
 * - 有报告日志ID：显示「AI智评报告」链接（点击交由父组件打开）；
 * - 检测中：显示「（AI评审中）」与「刷新AI评审结果」按钮；
 * - 已出评阅结果：追加显示「AI智评得分」。
 */
export default {
  name: "AiReviewActions",
  props: {
    /** 后端返回的 AI 摘要（AiSummaryVO），为空表示不可用 */
    aiSummary: {
      type: Object,
      default: null,
    },
  },
  computed: {
    reportLogId() {
      return this.aiSummary ? this.aiSummary.reportLogId : "";
    },
    underway() {
      return Boolean(this.aiSummary && this.aiSummary.underway);
    },
    evaluation() {
      return this.aiSummary ? this.aiSummary.evaluation : "";
    },
  },
};
</script>
